import { Controller } from "@hotwired/stimulus"
import { debounce } from "lodash"

export default class extends Controller {
  /*
    Target definitions:
      search: The input box which is at the top of the territory form to filter results
      searchItem: Every item in the search box
      territoryForm: the form element which wraps the location select box
      locationResults: The results div which displays the locations
      hiddenTerritoryId: The hidden field to update the value when a territory is selected
      hiddenTerritoryName: To preserve the territory name in the form.
  */
  static targets = ["search", "searchItem", "territoryForm", "locationResults", "hiddenTerritoryId", "hiddenTerritoryName"]

  connect() {
    // Avoid sending too many requests to the backend
    this.searchTarget.addEventListener("input", debounce(this.handleInput.bind(this), 200));
  }

  handleInput(event) {
    const query = event.target.value.trim()
    // Block submitting the form with enter key
    if(event.key === 'Enter') {
      event.preventDefault();
    }

    if (query.length > 2) {
      this.locationResultsTarget.classList.remove("hidden");
      this.territoryFormTarget.requestSubmit();
    } else {
      this.locationResultsTarget.classList.add("hidden");
    }

    if (query.length === 0) {
      this.locationResultsTarget.classList.add("hidden");
    }
  }

  selectLocation(event){
    let searchValue = event.currentTarget.textContent.trim();
    this.searchTarget.value = searchValue;
    this.locationResultsTarget.classList.add("hidden");
    // Update the hidden field value with the territory id and territory name
    this.hiddenTerritoryIdTarget.value = event.currentTarget.dataset.id;
    this.hiddenTerritoryNameTarget.value = searchValue;
  }
}
